export const secondsToTimeString = (seconds: number) => {
  return seconds < 3600
    ? new Date(seconds * 1000).toISOString().substring(14, 19)
    : new Date(seconds * 1000).toISOString().substring(11, 19)
}